import { createFileRoute } from "@tanstack/react-router";

import { FulfilFormPage } from "~/pages/connection-new/fulfil-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/fulfil",
)({
  component: FulfilFormPage,
});
